import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord } from '@common/models';

export interface ISalesSubCategoryModel extends IModel {
  salesSubCategoryId: number;
  name: string;
  displayName: string;
  sortOrder: number;
  salesCategoryId: number;
  salesCategoryName: string;
  salesCategoryDisplayName: string;
  salesCategorySortOrder: number;
  fullDisplayName: string;
  shouldSendToRX: boolean;
  sourceSystemId: number;
  sourceSystemKey: string;
}

export class SalesSubCategoryModel
  extends Model
  implements ModelRecord<ISalesSubCategoryModel>
{
  salesSubCategoryId: number;
  name: string;
  displayName: string;
  sortOrder: number;
  salesCategoryId: number;
  salesCategoryName: string;
  salesCategoryDisplayName: string;
  salesCategorySortOrder: number;
  fullDisplayName: string;
  shouldSendToRX: boolean;
  sourceSystemId: number;
  sourceSystemKey: string;

  constructor(params?: ISalesSubCategoryModel) {
    super(params);
    this.salesSubCategoryId = defaultTo(params?.salesSubCategoryId, 0);
    this.name = defaultTo(params?.name, '');
    this.displayName = defaultTo(params?.displayName, '');
    this.sortOrder = defaultTo(params?.sortOrder, 999);
    this.salesCategoryId = defaultTo(params?.salesCategoryId, 0);
    this.salesCategoryName = defaultTo(params?.salesCategoryName, '');
    this.salesCategoryDisplayName = defaultTo(
      params?.salesCategoryDisplayName,
      '',
    );
    this.salesCategorySortOrder = defaultTo(params?.salesCategorySortOrder, 0);
    this.fullDisplayName = defaultTo(params?.fullDisplayName, '');
    this.shouldSendToRX = defaultTo(params?.shouldSendToRX, false);
    this.sourceSystemId = defaultTo(params?.sourceSystemId, 0);
    this.sourceSystemKey = defaultTo(params?.sourceSystemKey, '');
  }
}
